import { ConfirmationPage } from "@/features/hca-public-registrace";
import { PublicShellWithDiagnoza } from "@/route-helpers/public-shell-with-diagnoza";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/potvrzeni/$token")({
  component: PotvrzeniRoute,
});

function PotvrzeniRoute() {
  const { token } = Route.useParams();
  return (
    <PublicShellWithDiagnoza>
      <ConfirmationPage token={token} />
    </PublicShellWithDiagnoza>
  );
}
